import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/Card';
import { cn } from '@/lib/utils';

/** Skeleton de card de indicador da Diretoria (KPI + sparkline + linhas). */
export const DiretoriaIndicatorCardSkeleton: React.FC<{
  title?: string;
  description?: string;
}> = ({ title, description }) => {
  return (
    <Card
      className="relative h-full border-border/80"
      aria-busy="true"
      aria-label={title ? `Carregando ${title}` : 'Carregando indicador'}
    >
      <CardHeader className="pb-2 pr-10">
        {title ? (
          <div className="text-base font-semibold leading-snug text-foreground/80">{title}</div>
        ) : (
          <div className="h-5 w-2/3 animate-pulse rounded bg-muted-foreground/20" />
        )}
        {description ? (
          <p className="line-clamp-2 text-xs text-muted-foreground">{description}</p>
        ) : (
          <div className="mt-2 h-3 w-full animate-pulse rounded bg-muted-foreground/15" />
        )}
      </CardHeader>
      <CardContent className="space-y-3 pt-0 animate-pulse">
        <div className="space-y-2">
          <div className="h-3 w-24 rounded bg-muted-foreground/20" />
          <div className="h-8 w-32 rounded bg-muted-foreground/25" />
        </div>
        <div className="h-12 w-full rounded bg-muted-foreground/15" />
        <div className="flex items-center justify-between gap-2 border-t border-border/60 pt-2">
          <div className="h-3 w-20 rounded bg-muted-foreground/20" />
          <div className="h-4 w-16 rounded bg-muted-foreground/20" />
        </div>
        <div className="flex items-center justify-between gap-2 border-t border-border/60 pt-2">
          <div className="h-3 w-24 rounded bg-muted-foreground/20" />
          <div className="h-4 w-14 rounded bg-muted-foreground/20" />
        </div>
        <div className="h-3 w-20 rounded bg-muted-foreground/15" />
      </CardContent>
    </Card>
  );
};

/** Bloco retangular para gráficos / seções em loading. */
export const DiretoriaBlockSkeleton: React.FC<{
  className?: string;
  label?: string;
}> = ({ className, label = 'Carregando' }) => (
  <div
    className={cn('animate-pulse rounded-md bg-muted-foreground/15', className)}
    aria-busy="true"
    aria-label={label}
  />
);
